import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useForm from '@components/form/hooks/useForm';

import { updateUserPassword } from '@actions/users';
import { getUserIsPosting, getUserPostSuccess } from '@selectors/users';
import { HandleSubmit } from 'src/types/shared/Functions';

export default function useUpdateUserPassword(userID: number): UseUpdateUserPasswordReturn {
    const dispatch = useDispatch();

    const [formState, handleChange] = useForm({ password: '', confirmPassword: '' });

    const handleSubmit = useCallback(() => {
        dispatch(updateUserPassword(userID, formState));
    }, [dispatch, userID, formState]);

    const postSuccess = useSelector(getUserPostSuccess);

    const isPosting = useSelector(getUserIsPosting);

    return {
        handleSubmit,
        formState,
        handleChange,
        isPosting,
        postSuccess,
    };
}

interface FormState {
    password: string;
    confirmPassword: string;
}

interface UseUpdateUserPasswordReturn {
    handleSubmit: HandleSubmit;
    formState: FormState;
    handleChange: <T>(name: 'password' | 'confirmPassword', value: T) => void;
    isPosting: boolean;
    postSuccess: boolean;
}
